import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { withStyles } from "@material-ui/core/styles";
import { changeSelected, setLayouts } from "../redux/actions/layoutActions";
import axios from "../AxiosClient";

const styles = (theme) => ({
  root: {
    marginLeft: 10,
  },
});

export class PortalTabs extends Component {
  static propTypes = {
    userTabs: PropTypes.bool.isRequired,
    onRemoveTab: PropTypes.func.isRequired,
  };

  render() {
    const { classes } = this.props;
    let value = this.props.layouts.filter((l) => l.id === this.props.selected).length > 0 
    ? this.props.layouts.findIndex((l) => l.id === this.props.selected)
    : 0
  
    return (
      <Tabs
        scrollButtons={this.props.isMobile ? "on" : "auto"}
        value={value}
        onChange={this.handleChange}
        variant="scrollable"
      >
        {this.props.titles.map((item, idx) => {
          return <Tab key={idx} label={item.title} />;
        })}
      </Tabs>
    );
  }

  handleChange = (event, value) => {
    if (value || value === 0) {
      let currentLayouts = this.props.layouts;
      currentLayouts.forEach(function(layout, index) {
        if (typeof layout.gridLayout === "string") {
          layout.gridLayout = JSON.parse(layout.gridLayout);
        }
      });
      this.props.setLayouts(currentLayouts);
      this.props.changeSelected(this.props.titles[value].id);
    }
  };

  onDragEnd(result) {
    // dropped outside the list
  }
}

const mapStateToProps = (state) => ({
  titles: state.layout.tabs,
  selected: state.layout.selectedTab,
  layouts: state.layout.layouts,
  isMobile: state.screen.isMobile,
});

const mapDispatchToProps = {
  changeSelected,
  setLayouts,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PortalTabs));
